


















































import { Component, Vue, Watch } from "vue-property-decorator";
import Recorder from "@/components/record/recorder.vue";
import LearnerResults from "@/views/learner/learnerresults.vue";
import bodymovin from "lottie-web";
import resultsprocessing from "@/assets/lottiefiles/resultsprocessing.json";
import FloatingParrot from "@/assets/images/parrot/FloatingParrot.svg?inline";
import { NewResults } from "../../types/NewResults";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    FloatingParrot,
    Recorder,
    LearnerResults,
  },
})
export default class AssessmentRecord extends Vue {
  private results: NewResults | null = null;
  private finishedRecording: boolean = false;
  private timenow = Date.now();
  private recordError: string | null = null;
  private readyToRecord: boolean = false;
  private displayNoMediaAccessError = false;
  private isFailed: boolean = false;
  private resetRecorder = Date.now();
  private exerciseID = 1029;

  @Getter private JWT!: string;
  @Getter private UID!: string;

  private gotoNext() {
    this.$emit("gotoNext");
  }

  private onProcessing() {
    this.finishedRecording = true;
    let svgContainer = this.$refs.processing as Element;
    this.lottieInit(svgContainer!);
  }

  private lottieInit(el: Element) {
    bodymovin.loadAnimation({
      container: el,
      renderer: "svg",
      loop: true,
      animationData: resultsprocessing,
    });
  }

  private resetRecording() {
    this.results = null;
    this.recordError = null;
    this.finishedRecording = false;
    this.timenow = Date.now();
    this.recordError = null;
  }

  private onRecordFail(e: Event) {
    console.log("error called", e);
    if (e.type === "missing-av-permissions") {
      this.recordError = "Please enable your microphone access and try again.";
    } else {
      this.recordError =
        "A network or system error has occured. Please try again";
    }
  }

  private onResults(myresults: any) {
    this.results = myresults;
    this.recordError = null;
    console.log("on assessment", this.results);
    if (this.results !== null && this.results.Errors !== null) {
      this.recordError = this.results.Errors;
    } else {
      this.$emit("postAssessment");
    }
  }
}
